// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._5ba5R1sIx{}._5Os4H1oax{}._4yyHRZEXx{background-color:var(--error-bg)}._5ueWR1OEx{background-color:var(--warning-bg)}._2GmgAnPjx{background-color:var(--banner-blue)}._2LdbQfXTx{align-items:center;flex:0 1 100%}._7rL7Ox9mx{flex:0 0 auto;align-self:flex-end;margin-left:8px}@media (max-width: 767px){html[data-supports-mobile=true] ._7rL7Ox9mx{margin-top:8px}}.cVtrgtJKx ._2LdbQfXTx{align-items:stretch}.cVtrgtJKx ._5I3TPUkhx{margin-left:20px}.cVtrgtJKx ._7rL7Ox9mx{margin-left:20px}._5RMHtz5Ix{flex-shrink:0}._5I3TPUkhx{margin-left:8px;color:var(--primary-text)}.yUGNqFsZx ._5I3TPUkhx p{margin:0}._5hIs0Heyx ._5I3TPUkhx{margin-left:0}.HAsH8Ad6x{display:flex;flex-direction:column}.HAsH8Ad6x ._2LdbQfXTx :first-child{align-self:flex-start}@media (max-width: 767px){html[data-supports-mobile=true] ._4ZBzLP2mx{display:flex;flex-direction:column}}._2SlIkIkEx ._2LdbQfXTx :first-child{align-self:flex-start}._25bZjDCax ._2LdbQfXTx :first-child{align-self:flex-end}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"compact": "_5ba5R1sIx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-m"] + "",
	"normal": "_5Os4H1oax " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-m"] + "",
	"error": "_4yyHRZEXx",
	"warning": "_5ueWR1OEx",
	"infoEmphasized": "_2GmgAnPjx",
	"content": "_2LdbQfXTx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"button-container": "_7rL7Ox9mx",
	"buttonContainer": "_7rL7Ox9mx",
	"with-illustration": "cVtrgtJKx",
	"withIllustration": "cVtrgtJKx",
	"text": "_5I3TPUkhx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["paragraph-m"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["wordwrap"] + "",
	"illustration": "_5RMHtz5Ix",
	"markdown": "yUGNqFsZx",
	"without-image": "_5hIs0Heyx",
	"withoutImage": "_5hIs0Heyx",
	"multiline": "HAsH8Ad6x",
	"liveRegion": "_4ZBzLP2mx",
	"alignIconTop": "_2SlIkIkEx",
	"alignIconBottom": "_25bZjDCax"
};
module.exports = exports;
